import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-remove-user',
  templateUrl: './remove-user.component.html',
  styleUrls: ['./remove-user.component.css']
})
export class RemoveUserComponent implements OnInit {

  constructor(public removeUserModal: NgbActiveModal) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standards-management/modals/remove-user/remove-user.component.ts